var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TRANSLATION_CONTEXT } from './componentConfig';
import { DocumentStatus, isChatFeatureConfigured, } from '@account-verification-frontend/types';
import { Summary } from './Summary';
import { withTranslator } from '@wh/ui-translations';
export var SummaryContainer = withTranslator(function (props) {
    var translate = function (msg) { return props.t(TRANSLATION_CONTEXT)(msg); };
    var isChatEnabled = isChatFeatureConfigured() && props.data.some(function (_a) {
        var status = _a.status;
        return status === DocumentStatus.REJECTED;
    });
    var propsWithTranslator = __assign(__assign({}, props), { t: translate, isChatEnabled: isChatEnabled });
    return React.createElement(Summary, __assign({}, propsWithTranslator));
});
//# sourceMappingURL=SummaryContainer.js.map